// Vendor
import * as React from 'react';
import { SPOT_CLEANOUT_LIGHT } from '@thredup/styleguide/src/variables/colors';

// Internal
import { Image } from '@src/components/Image/Image';
import { DEFAULT_SAL_PROPS, SAL_DELAY } from '@src/config/sal';

const EconomicUncertainty: React.FC = () => {
  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS} className="max-w-xl">
        In Economic Uncertainty, More Consumers Will Shift to Thrift
      </h1>
      <h2
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={SAL_DELAY * 1}
        className="max-w-xl mb-8"
      >
        Resale delivers value when household budgets shrink.
      </h2>

      <div className="flex flex-wrap justify-around items-baseline">
        <div
          {...DEFAULT_SAL_PROPS}
          data-sal-delay={SAL_DELAY * 2}
          className="text-center mb-8"
        >
          <Image
            alt="thredUP cleanout bag icon"
            className="m-auto"
            fileName="tu-box-icon.png"
            maxWidth={74}
          />
          <p>
            <span className="tup-number font-bold">4 in 5</span>
            <br />
            people say they have or are
            <br /> open to shopping secondhand
            <br /> when money gets tight.<sup>3</sup>
          </p>
        </div>
        <div
          {...DEFAULT_SAL_PROPS}
          data-sal-delay={SAL_DELAY * 3}
          className="text-center mb-8"
        >
          <Image
            alt="thredUP cleanout bag icon"
            className="m-auto"
            fileName="piggy-bank-icon.png"
            maxWidth={64}
          />
          <p>
            <span className="tup-number font-bold">79%</span>
            <br />
            of consumers plan to cut
            <br /> their apparel budget in the
            <br /> next 12 months.<sup>3</sup>
          </p>
        </div>
        <div
          {...DEFAULT_SAL_PROPS}
          data-sal-delay={SAL_DELAY * 4}
          className="text-center"
        >
          <Image
            alt="thredUP cleanout bag icon"
            className="m-auto"
            fileName="cleanout-bag-icon.png"
            maxWidth={47}
          />
          <p>
            <span className="tup-number font-bold">2 in 3</span>
            <br />
            people who have never sold
            <br /> their clothes are now open
            <br /> to it. The #1 reason is to
            <br /> make money.<sup>3</sup>
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
        <div
          {...DEFAULT_SAL_PROPS}
          data-sal-delay={SAL_DELAY * 5}
          className="bg-cleanout-background text-center p-8"
        >
          <p>
            <span
              className="tup-number font-bold"
              style={{ color: SPOT_CLEANOUT_LIGHT }}
            >
              88%
            </span>
            <br />
            of consumers adopted a new thrifty hobby
            <br /> during Covid that they plan to continue. <br />
            (Mending clothes, growing a garden.)<sup>3</sup>
          </p>
        </div>
        <div
          {...DEFAULT_SAL_PROPS}
          data-sal-delay={SAL_DELAY * 6}
          className="bg-cleanout-background p-12"
        >
          <p className="tup-body mb-0">
            “The next normal has started to emerge, with consumers indicating
            they will adopt long-term behavioral changes that will last beyond
            Covid.”
            <br />
            <strong>– McKinsey & Company</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export { EconomicUncertainty };
